var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRssFeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "feed",
    clipPath: "url(#clip0_8982_2463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.9125 0.5H5.28748C2.69864 0.5 0.599976 2.59867 0.599976 5.1875V20.8125C0.599976 23.4013 2.69864 25.5 5.28748 25.5H20.9125C23.5013 25.5 25.6 23.4013 25.6 20.8125V5.1875C25.6 2.59867 23.5013 0.5 20.9125 0.5Z",
    fill: "#FFA71A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.84998 22.375C8.57587 22.375 9.97498 20.9759 9.97498 19.25C9.97498 17.5241 8.57587 16.125 6.84998 16.125C5.12409 16.125 3.72498 17.5241 3.72498 19.25C3.72498 20.9759 5.12409 22.375 6.84998 22.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.72498 13C6.21138 13 8.59595 13.9877 10.3541 15.7459C12.1123 17.504 13.1 19.8886 13.1 22.375H16.225C16.225 19.0598 14.908 15.8804 12.5638 13.5362C10.2196 11.192 7.04018 9.875 3.72498 9.875V13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.72498 6.75C5.77688 6.75 7.80869 7.15415 9.7044 7.93938C11.6001 8.72461 13.3226 9.87554 14.7735 11.3265C16.2244 12.7774 17.3754 14.4999 18.1606 16.3956C18.9458 18.2913 19.35 20.3231 19.35 22.375H22.475C22.475 17.4022 20.4995 12.6331 16.9832 9.11675C13.4669 5.60044 8.69778 3.625 3.72498 3.625V6.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8982_2463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.599976 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRssFeed);
export default __webpack_public_path__ + "static/media/rss_feed.28bb2e80591f9b9543bc60451eae282e.svg";
export { ForwardRef as ReactComponent };